var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 48,
    viewBox: "0 0 52 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#iu6thi0dya)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m38.627 30.743 12.459-12.146h-.004l-17.278-2.51-.045-.09L26.075.425l-.106.214-7.625 15.447-.047.007-17.235 2.504.146.144 12.36 12.047-.007.04-2.935 17.108-.01.064 15.353-8.07.106-.056 15.43 8.113.028.013-2.953-17.212.047-.045z",
    fill: "#806500",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24.994 26.33.07-.021-.113-.036.043.057zM24.907 26.258v.072l.042-.06-.042-.012z",
    fill: "#FFB500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m24.95 26.27-.043.06v.03l.087-.03-.043-.057-.002-.003z",
    fill: "#FFB500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m24.951 26.273.113.036 24.956-8.137-17.278-2.51-.045-.09L24.95 26.27l.002.003z",
    fill: "#CCA300"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m24.951 26.273-.002-.003.002.003zM24.88 26.368l.027-.008v-.03l-.028.038z",
    fill: "#FFB500"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m24.95 26.27 7.747-10.698L25.013 0l-.106.215v25.994l.042.061z",
    fill: "#FFD600"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m24.95 26.27-.043-.061v.049l.042.012z",
    fill: "#FFB500"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m24.994 26.33 15.45 21.233.027.012-2.952-17.212.046-.044-12.5-4.01-.071.02z",
    fill: "#CCA300"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.907 26.36v13.144l.106-.055 15.43 8.114-15.45-21.233-.086.03zM50.02 18.172 25.064 26.31l12.501 4.01 12.46-12.147h-.005z",
    fill: "#FFD600"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.88 26.368 9.563 47.511l-.01.064 15.353-8.07V26.36l-.028.008zM24.907.215l-7.625 15.447-.047.006 7.672 10.54V.216z",
    fill: "#CCA300"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m24.907 26.209-7.672-10.541L0 18.172l.147.145 24.76 7.94v-.048zM12.5 30.404 9.563 47.51l15.315-21.143-12.38 4.036z",
    fill: "#FFD600"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M24.907 26.33v-.072L.147 18.317l12.358 12.046-.006.04 12.38-4.035.028-.038z",
    fill: "#CCA300"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "iu6thi0dya"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h51.086v48H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.55aea2c0c7b09b3e6c90fc357d6b5922.svg";
export { ForwardRef as ReactComponent };